import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Tab } from './tab.interface';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { AsyncPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IsFeatureAvailableDirective } from '../../directives/is-feature-available.directive';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, IsFeatureAvailableDirective, MatTabNavPanel, AsyncPipe, MatIconModule]
})
export class TabsComponent {
  @Input() public tabs$: Observable<Tab[]>;
}
